import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { Wrapper, Details, FlexContainer, Info } from './styled'

const CampaignItemSkeleton = () => {
  return (
    <Wrapper>
      <Skeleton containerClassName="container" width={64} height={64} />
      <Details>
        <Skeleton containerClassName="container" width={200} height={18} />
        <FlexContainer>
          <Info>
            <Skeleton containerClassName="container" width={150} height={12} />
            <Skeleton containerClassName="container" width={100} height={12} />
          </Info>
          <Skeleton containerClassName="container-button" style={{ alignSelf: 'end' }} width={80} height={30} />
        </FlexContainer>
      </Details>
    </Wrapper>
  )
}

export default CampaignItemSkeleton
